import { tKey, type I18nKey } from "@/core/i18n";
import { Tabs, TabsList, TabsTrigger } from "@/modules/shadcn/ui/tabs";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type ModelTab = "overview" | "outputs" | "parameters";

export interface ModelSubheaderProps {
  activeTab: ModelTab;
  onTabChange: (tab: ModelTab) => void;
  actions?: ReactNode;
}

const TABS: { key: ModelTab; label: I18nKey<"model"> }[] = [
  { key: "overview", label: tKey("model:tabs.overview") },
  { key: "outputs", label: tKey("model:tabs.outputs") },
  { key: "parameters", label: tKey("model:tabs.parameters") },
];

export const ModelSubheader = ({
  activeTab,
  onTabChange,
  actions,
}: ModelSubheaderProps) => {
  const { t } = useTranslation(["model", "common"]);
  return (
    <div className="flex h-12 shrink-0 items-end justify-between border-b border-black/10 bg-black/3 pr-6">
      <Tabs
        value={activeTab}
        onValueChange={(v) => v && onTabChange(v as ModelTab)}
        className="gap-0"
      >
        <TabsList variant="line" className="border-b-0! px-6">
          {TABS.map((tab) => (
            <TabsTrigger key={tab.key} value={tab.key}>
              {t(tab.label)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {actions && (
        <div className="flex h-full items-center gap-2">{actions}</div>
      )}
    </div>
  );
};
